export enum DurationErrorCode {
  FileTooLong = 'file-too-long',
  FileTooShort = 'file-too-short',
}
